module.exports = __webpack_public_path__ + "img/中山真未.0a03e57f.jpg";